import React from 'react';
import { Loader, BaasicConfirmModal, BaasicTable, BaasicHeader, BaasicSelect, BaasicModal } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { CustomLabel, WarehouseCodes } from 'modules/channel/pages';
import ReactTooltip from 'react-tooltip';

const ChannelListTemplate = ({
	t,
	viewStore,
	viewStore: { listStore, tableData, queryUtility, loading },
	showActions,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.CHANNELS"></BaasicHeader>
			<BaasicTable
				{...{ tableData, queryUtility, viewStore, showActions }}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
			<ReactTooltip />
			<BaasicConfirmModal modalParams={viewStore.deleteConfirmModal} />
			<BaasicConfirmModal modalParams={viewStore.syncConfirmModal} />
			<BaasicModal modalParams={viewStore.editChannelWarehouseCodesModal}>
				<WarehouseCodes parentViewStore={viewStore} />
			</BaasicModal>
			<BaasicModal modalParams={viewStore.customLabelModal} className="ReactModal--lrg-inter">
				<CustomLabel parentViewStore={viewStore} />
			</BaasicModal>
		</section>
	);
};

export default defaultTemplate(ChannelListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/channel/pages/ChannelListTemplate.jsx